export const setPipelineUsage = 'setPipelineUsage';
export const setTotalPipelineUsage = 'setTotalPipelineUsage';
export const setAvgPipelineUsage = 'setAvgPipelineUsage';
export const setPipelineCollectionUsage = 'setPipelineCollectionUsage';
